module.exports =
{
    apiKey: "AIzaSyAq4BLgznLhoIdk_PYcvajm0swSuYS1xjQ",
    authDomain: "codesession-96b21.firebaseapp.com",
    databaseURL: "https://codesession-96b21.firebaseio.com",
    projectId: "codesession-96b21",
    storageBucket: "codesession-96b21.appspot.com",
    messagingSenderId: "917711287840",
    appId: "1:917711287840:web:83e31386c4cab7194a2e45",
    measurementId: "G-CNYNB1Y5PE"
  }